import React, { PropsWithChildren } from 'react'
import classes from './headerOptionThree.module.scss'

export type HeaderOptionThreeProps = {
  component: string
  title: string
}

const HeaderOptionThree: React.FC<PropsWithChildren<HeaderOptionThreeProps>> = ({ title }) =>  !title ? null :  (
  <div className={classes.headerOptionOneContainer}>
    <div className={classes.headerOptionThreeWrapper}>
      <h1 className={classes.title}>{title}</h1>
    </div>
  </div>
)


export default HeaderOptionThree
